import React from "react"
import { PageSection } from "@alexanderathoodly/ui-library"
import MarkdownContent from "../markdowncontent"

export interface PageMarkdownSectionProps {
    template: "page-md-content"
    content: string
    color: "light-blue" | "white"
    id?: string
}

const PageMarkdownSection = ({ id, color, content }: PageMarkdownSectionProps): JSX.Element => {
    return (
        <PageSection backgroundColor={color} id={id || undefined}>
            {content && <MarkdownContent content={content} className="medium-width-content" />}
        </PageSection>
    )
}

export { PageMarkdownSection }
